/**
 * @author Sirisha.M
 * @description 
 */
import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { beijingChartMockJson } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const BeijingChart = (props) => {
  const [option, setOption] = useState({});
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  const requestCheckRef = useRef(true);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());
  let data = [];

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    translationCache,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);


  const getOption = () => {
    let theme = props.selectedThemeing;
    let option = {
      title: {},
      color: props.graphprops.colors,
      tooltip: {
        trigger: 'axis'
      },
      visualMap: {
        textStyle: {
          fontSize: 15,
          color: theme === 'lightTheme' ? 'black' : 'white'
        },

        top: 20,
        //right: "auto",
        left: 'center',
        align: 'left',
        orient: 'horizontal',

        pieces:
          props.graphprops &&
            props.graphprops &&
            props.graphprops.beijingLine &&
            props.graphprops.beijingLine.VisualMap
            ? JSON.parse(props.graphprops.beijingLine.VisualMap)
            : [],

        outOfRange: {
          color: '#999'
        }
      },
      xAxis: {
        data: data.map(function (item) {
          return item.date;
        }),
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        }
      },
      yAxis: [],

      toolbox: {
        showTitle: false,
        orient: 'vertical',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: theme === 'lightTheme' ? 'white' : 'black',
            name: props.graphprops.title
            // backgroundColor: "black",
          }
        }
      },
      // toolbox: {
      //   showTitle: false,
      //   orient: "vertical",
      //   feature: {
      //     saveAsImage: {
      //       title: "download",
      //       name: this.props.graphprops.title,
      //       backgroundColor: "black"
      //     }
      //   }
      // },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          backgroundColor: '#9a9191',

          textStyle: {
            color: 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ],

      series: {
        name: 'value',
        type:
          props.graphprops &&
            props.graphprops.beijingLine &&
            props.graphprops.beijingLine.beijingType
            ? props.graphprops.beijingLine.beijingType
            : 'line',
        data: data.map(function (item) {
          return item.value;
        })

        // markLine: {
        //   silent: true,
        //   data: [
        //     {
        //       yAxis: 20
        //     },
        //     {
        //       yAxis: 40
        //     },
        //     {
        //       yAxis: 60
        //     },
        //     {
        //       yAxis: 80
        //     },
        //     {
        //       yAxis: 100
        //     }
        //   ]
        // }
      }
    };
    return option;
  };

  const getData = async (props, theme) => {
    let { graphprops } = props;
    requestCheck.current = false;
    requestCheckRef.current = false;
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = beijingChartMockJson;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (json && Array.isArray(json)) {
        let dates = [];
        let values = [];
        let name = '';
        let tagnames = [];
        let seriesarray = [];
        let legendsdata = [];
        json.map((val) => {
          if (val.Name !== name) {
            if (tagnames.indexOf(val.Name) === -1) {
              tagnames.push(val.Name);
              name = val.Name;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 18,
                  fontWeight: 'bold'
                }
              });
            }
          }
          return {};
        });

        let yAxisData = [];

        if (props.graphprops && props.graphprops.beijingLine &&
          props.graphprops.beijingLine.YAxis &&
          Array.isArray(props.graphprops.beijingLine.YAxis)) {
          yAxisData = [...props.graphprops.beijingLine.YAxis];
        }

        let yaxis = yAxisData.map((value, index) => {
          let axis = {};
          axis.splitLine = {
            show: true,
            lineStyle: {
              color: '#504c4c'
            }
          };
          axis.triggerEvent = true;
          axis.axisLine = {
            lineStyle: {
              // color: "white"
              color:
                props.graphprops.colors[index] !== undefined
                  ? value.tags.length > 1
                    ? 'white'
                    : props.graphprops.colors[index]
                  : 'white'
            }
          };
          axis.max = value.max;
          axis.min = value.min;
          axis.offset = value.offset;
          axis.interval = value.interval;
          axis.position = value.position;
          axis.name = value.name;
          //  axis.nameLocation = (value.nameLocation==undefined)?"top":"center";
          axis.tags = value.tags;
          return axis;
        });

        yaxis.unshift({
          splitLine: {
            show: true,
            lineStyle: {
              color: '#504c4c'
            }
          },
          triggerEvent: true,
          axisLine: {
            lineStyle: {
              color: theme === 'lightTheme' ? 'black' : 'white'
            }
          },
          tags: []
        });

        tagnames.map((tagval, tagindex) => {
          values = [];
          json.map((jsonval) => {
            if (tagnames[0] === jsonval.Name && tagindex === 0) {
              let date =
                graphprops && graphprops.type === 'live'
                  ? moment
                    .utc(jsonval.DateTime)
                    .tz(props.currentTimeZone)
                    .format('DD/MM/YYYY HH:mm:ss')
                  : moment(jsonval.DateTime).format('DD/MM/YYYY HH:mm:ss');
              dates.push(date);
              // dates.push(
              //   moment(jsonval.DateTime)
              //     .utc()
              //     .format("DD/MM/YYYY HH:mm:ss")
              // );
            }
            if (tagval === jsonval.Name) {
              values.push(jsonval.Value);
            }
            return {};
          });
          if (props.graphprops.linetype === 'area') {
            if (yaxis.length > 1) {
              yaxis.map((axis, axisindex) => {
                if (axis.tags.indexOf(tagval) !== -1) {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    type:
                      props.graphprops &&
                        props.graphprops.beijingLine &&
                        props.graphprops.beijingLine.beijingType
                        ? props.graphprops.beijingLine.beijingType
                        : 'line',
                    yAxisIndex: axisindex,
                    areaStyle: {},
                    smooth: true
                  });
                }
                return {};
              });
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type:
                  props.graphprops &&
                    props.graphprops.beijingLine &&
                    props.graphprops.beijingLine.beijingType
                    ? props.graphprops.beijingLine.beijingType
                    : 'line',
                areaStyle: {},
                smooth: true
              });
            }
          } else {
            if (yaxis.length > 1) {
              yaxis.map((axis, axisindex) => {
                if (axis.tags.indexOf(tagval) !== -1) {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    yAxisIndex: axisindex,
                    type:
                      props.graphprops &&
                        props.graphprops.beijingLine &&
                        props.graphprops.beijingLine.beijingType
                        ? props.graphprops.beijingLine.beijingType
                        : 'line'
                    // type: 'line'
                  });
                }
                return {};
              });
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type:
                  props.graphprops &&
                    props.graphprops.beijingLine &&
                    props.graphprops.beijingLine.beijingType
                    ? props.graphprops.beijingLine.beijingType
                    : 'line'
                // type: 'line'
              });
            }
          }
          return {};
        });

        const option = cloneDeep(getOption());
        let series = await trendLabelTranslation(seriesarray, translationCache);
        option.xAxis.data = [...dates];
        option.yAxis = [...yaxis];
        option.series = [...series];
        option.legend = [...legendsdata];
        setOption(option);
        setRefreshDateTime(moment());
      }
    }
  };

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '80%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(BeijingChart);
